import { render } from "./ScrollProgressBar.vue?vue&type=template&id=0e0636d0"
import script from "./ScrollProgressBar.vue?vue&type=script&lang=js"
export * from "./ScrollProgressBar.vue?vue&type=script&lang=js"

import "./ScrollProgressBar.vue?vue&type=style&index=0&id=0e0636d0&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__